<template>
    <v-dialog v-model="dialog" persistent style="background-color: red;" max-width="600" v-resize="onResize">
        <v-card class="confirm-delete-group-card">
            <v-row no-gutters class="standard-row font-theme d-flex justify-center header-confirm-delete-group-modal text-center">
                ยืนยันลบ {{ tempGroup.type_text }}
            </v-row>
            <v-row no-gutters class="standard-row font-theme" style="padding-bottom: 10%;">
                <v-col cols="12" sm="6" md="6" lg="6" class="d-flex justify-end pr-sm-9 px-9 pl-sm-0">
                    <v-btn color="#0B68D6" @click="confirmDeleteGroup()" height="53" :width="windowSize.x <= 600? '100%' :'150'" class="white--text button-confirm-delete-group-modal">
                        ยืนยัน
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="pl-sm-9 px-9 pl-sm-0 pt-6 pt-sm-0">
                    <v-btn @click="dialog = false" color="#F5F5F5" height="53" :width="windowSize.x <= 600? '100%' :'150'" class="button-confirm-delete-group-modal" style="border: 1px solid #000000;">
                        ยกเลิก
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            tempGroup: {},
            dialog: false,
            windowSize: { x: 0 }
        }),
        mounted () {
            EventBus.$on('openConfirmDeleteGroupModal', this.openModal)
        },
        beforeDestroy () {
            EventBus.$off('openConfirmDeleteGroupModal')
        },
        methods: {
            openModal(data) {
                this.tempGroup = data
                this.dialog    = true
            },
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            confirmDeleteGroup() {
                EventBus.$emit('afterConfirmDeleteGroup', this.tempGroup)
                this.dialog = false
            }
        }
    }
</script>

<style>
    .confirm-delete-group-card {
        border-radius: 20px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
        background-color: #F4F4F4 !important;
    }

    .header-confirm-delete-group-modal {
        font-size: 32px;
        font-weight: 700;
        padding-top: 14.6%;
        padding-bottom: 10%;
    }

    .button-confirm-delete-group-modal {
        border-radius: 20px;
        font-size: 20px !important;
        font-weight: 700;
        box-shadow: none;
    }
</style>